import {
  Action,
  ActionType,
  IDefaultSettingResponse,
} from "models/setting/default";
import createReducer from "redux/createReducer";

export interface DefaultSettingReducerType {
  loading: boolean;
  error?: string;
  defaultSettingResponse?: IDefaultSettingResponse;
}

const defaultState: DefaultSettingReducerType = {
  loading: false,
  error: undefined,
  defaultSettingResponse: undefined,
};

export const defaultSettingReducer = createReducer<DefaultSettingReducerType>(
  defaultState,
  {
    [ActionType.DEFAULT_SETTING](state: DefaultSettingReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DEFAULT_SETTING_ERROR](
      state: DefaultSettingReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DEFAULT_SETTING_SUCCESS](
      state: DefaultSettingReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        defaultSettingResponse: action.payload,
      };
    },

    [ActionType.DEFAULT_SETTING_RESET](state: DefaultSettingReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        defaultSettingResponse: undefined,
      };
    },
  }
);
